const _excluded = ["errorHeadline", "errorDescription", "errorImage", "projectConfig", "backToAction", "siteConfig", "fallbackImage", "backToUrl", "path", "onSearch", "templateWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { HeroPrimary } from '@cbhq/cdx-components';
import { useContentfulMicrocopy } from '../globals/microcopy.js';
import { mapEntryLink } from '../globals/navlink.js';
import { PageTemplateLayout } from './PageTemplateLayout.js';
import { PageTemplateProviders } from './PageTemplateProviders.js';
import { jsx } from 'react/jsx-runtime';
const ERROR_TEMPLATE_CONTENT_MODEL_ID = 'cdxTemplateError';

// TODO: Remove <backToUrl> and <microcopies> and use <backToAction> instead once all error pages migrated to cdx-template-error

function ErrorTemplate(_ref) {
  let errorHeadline = _ref.errorHeadline,
    errorDescription = _ref.errorDescription,
    errorImage = _ref.errorImage,
    projectConfig = _ref.projectConfig,
    backToAction = _ref.backToAction,
    siteConfig = _ref.siteConfig,
    fallbackImage = _ref.fallbackImage,
    _ref$backToUrl = _ref.backToUrl,
    backToUrl = _ref$backToUrl === void 0 ? '/' : _ref$backToUrl,
    path = _ref.path,
    onSearch = _ref.onSearch,
    templateWidth = _ref.templateWidth,
    pageTemplateProviderProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(PageTemplateProviders, _objectSpread(_objectSpread({
    siteConfig: siteConfig
  }, pageTemplateProviderProps), {}, {
    children: /*#__PURE__*/jsx(PageTemplateLayout, {
      siteConfig: siteConfig,
      projectConfig: projectConfig,
      path: path,
      templateWidth: templateWidth,
      children: /*#__PURE__*/jsx(Content, {
        errorHeadline: errorHeadline,
        errorDescription: errorDescription,
        errorImage: errorImage,
        fallbackImage: fallbackImage,
        backToUrl: backToUrl,
        backToAction: backToAction
      })
    })
  }));
}
function Content({
  errorHeadline,
  errorDescription,
  errorImage,
  fallbackImage,
  backToUrl,
  backToAction
}) {
  const microcopies = useContentfulMicrocopy();
  const linkProps = backToAction ? mapEntryLink(backToAction) : undefined;
  return /*#__PURE__*/jsx(HeroPrimary, {
    headline: errorHeadline || '',
    layout: "left",
    excerpt: errorDescription,
    mediaAlt: errorImage?.fields.title || 'error',
    mediaUrl: errorImage?.fields.file.url || fallbackImage,
    ctaButtonLabel: linkProps?.label || microcopies.global?.goBackToCoinbase,
    ctaButtonUrl: linkProps?.url || backToUrl,
    imageFit: "contain"
  });
}
export { ERROR_TEMPLATE_CONTENT_MODEL_ID, ErrorTemplate };
//# sourceMappingURL=Error.js.map
